var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6001 12.4292C21.6001 11.7834 21.5429 11.1704 21.4448 10.5737H12.2085V14.2601H17.4969C17.2598 15.4698 16.5651 16.4915 15.5352 17.1862V19.6384H18.6902C20.5375 17.9301 21.6001 15.4126 21.6001 12.4292Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2085 22.0167C14.8568 22.0167 17.0718 21.134 18.6902 19.6382L15.5352 17.1861C14.6524 17.7746 13.5326 18.1342 12.2085 18.1342C9.65013 18.1342 7.4841 16.4096 6.7076 14.0801H3.45447V16.6057C5.06469 19.8098 8.37503 22.0167 12.2085 22.0167Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70756 14.0803C6.50322 13.4918 6.39696 12.8624 6.39696 12.2085C6.39696 11.5546 6.51139 10.9252 6.70756 10.3367V7.81104H3.45443C2.78419 9.13517 2.40002 10.6228 2.40002 12.2085C2.40002 13.7942 2.78419 15.2818 3.45443 16.6059L6.70756 14.0803Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2085 6.28241C13.6552 6.28241 14.9467 6.781 15.9684 7.75367L18.7638 4.95827C17.0718 3.37257 14.8568 2.3999 12.2085 2.3999C8.37503 2.3999 5.06469 4.6068 3.45447 7.81089L6.7076 10.3366C7.4841 8.00706 9.65013 6.28241 12.2085 6.28241Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.5111fa4c9c5fc74bfe405a39627d5370.svg";
export { ForwardRef as ReactComponent };